/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Chat_Recap_Card_LinkInputs */



/**
* | output |
* | --- |
* | "Open the conversation of {date}" |
*
* @param {Chat_Recap_Card_LinkInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_recap_card_link = /** @type {((inputs: Chat_Recap_Card_LinkInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Recap_Card_LinkInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Open het gesprek van ${i?.date}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ouvrir la conversation du ${i?.date}`)
	return /** @type {LocalizedString} */ (`Open the conversation of ${i?.date}`)
});